import { isDemoMode } from 'api/demo'

export function useIsDemoMode() {
  return isDemoMode()
}
